'use client';
import AchatForm from '@/components/achat/AchatForm';
import MonerisCheckout from '@/components/achat/MonerisCheckout';
import Button from '@/components/Button';
import TirageTable from '@/components/homePage/TirageTable';
import Modal from '@/components/layout/Modal';
import {
  BootstrapContext,
  ConnectedStateContext,
  IsDesktopMediaContext,
  IsMobileMediaContext,
  IsTabletMediaContext,
  ToastContext,
} from '@/pagesComponents/Layout';
import * as achatsService from '@/services/achats';
import { fetchAchatModel } from '@/services/achats';
import Errors from '@/services/errors';
import { fetchHomePageModel } from '@/services/home';
import { useSearchParams } from 'next/navigation';
import { useContext, useEffect, useRef, useState } from 'react';

const Achats = () => {
  const bootstrap = useContext(BootstrapContext);
  const searchParams = useSearchParams();
  const tirageId = searchParams.get('tirageId');
  const updateToast = useContext(ToastContext);

  const [isConnected, setIsConnected] = useContext(ConnectedStateContext);
  const isMobileMedia = useContext(IsMobileMediaContext);
  const isTabletMedia = useContext(IsTabletMediaContext);
  const isDesktopMedia = useContext(IsDesktopMediaContext);

  const [pageModel, setPageModel] = useState({});
  const [tirageIdHook, setTirageIdHook] = useState(tirageId);
  const [achatResult, setAchatResult] = useState(null);

  const achatFormRef = useRef();

  const literals = {
    achatForm: 'achatForm',
  };
  const fetchTirage = async (tirageId) => {
    try {
      const data = await fetchAchatModel(tirageId);
      if (data instanceof Error) {
        throw data;
      }
      // const data = await result.json();
      setPageModel(data);
    } catch (e) {
      console.error(e);
      Errors.handleError(e, updateToast);
    }
  };
  const closeConfirmTransactionModal = () => {
    const modal = document.getElementById('confirmTransactionModal');
    const modalInstance = bootstrap.Modal.getOrCreateInstance(modal);
    modalInstance.hide();
  };
  const fetchLatestTirageId = async () => {
    try {
      const result = await fetchHomePageModel();
      if (result instanceof Error) {
        throw result;
      }
      const { data } = result;
      const nextTirageId = data.tirages[0].id;
      setTirageIdHook(nextTirageId);
    } catch (e) {
      Errors.handleError(e, updateToast);
    }
  };

  const handleAchatFormFlow = (data) => {
    setAchatResult(data);
  };
  const handleContinueTransaction = () => {
    const event = {
      preventDefault: () => {},
      target: document.getElementById(literals.achatForm),
    };
    achatFormRef.current.triggerHandleBonDeCommandeSubmit(event);
    closeConfirmTransactionModal();
  };
  const handleCancelTransaction = async () => {
    try {
      const response = await achatsService.monerisCancelTransaction(pageModel?.demandeAchat?.orderId);
      if (response instanceof Error) {
        return Errors.handleError(response, updateToast);
      }
      closeConfirmTransactionModal();
    } catch (e) {
      console.error(e);
      Errors.handleError(e, updateToast);
    }
  };

  useEffect(() => {
    // fetch data
    if (tirageIdHook) {
      fetchTirage(tirageIdHook);
    }
  }, [tirageIdHook]);

  useEffect(() => {
    if (!parseInt(tirageId)) {
      fetchLatestTirageId();
    }
  }, [tirageId]);

  useEffect(() => {
    if (pageModel?.demandeAchat?.statut === 4) {
      const modal = document.getElementById('confirmTransactionModal');
      const modalInstance = bootstrap.Modal.getOrCreateInstance(modal);
      modalInstance.show();
    }
  }, [pageModel]);

  return (
    <>
      <Modal
        title={'Transaction déja en cours'}
        id={'confirmTransactionModal'}
        label={'confirm transaction modal'}
      >
        <>
          <p>
            Nous avons trouvé une transaction en cours à votre nom d&apos;un montant de&nbsp;
            {pageModel?.demandeAchat?.montant}$ voulez-vous continuer avec cette dernière?
          </p>
          <ul>
            <li>Feuillets : {pageModel?.demandeAchat?.qteFeuillet}</li>
            <li>Moitié Moitié: {pageModel?.demandeAchat?.qteMoitieMoitie}</li>
          </ul>
        </>
        <>
          <div className="btn-group">
            <Button className="btn btn-sales" type={'button'} onClick={handleContinueTransaction}>
              Continuer La transaction
            </Button>
            <Button className="btn btn-secondary" type={'button'} onClick={handleCancelTransaction}>
              Annuler La transaction
            </Button>
          </div>
        </>
      </Modal>
      <div className="hero card sales-card my-3 py-3">
        <div className="card-title">
          <h2 className="text-center">Achat de cartes de BINGO</h2>
        </div>
        <div className="card-body">
          <h3 className="text-center fw-bold mb-3">Informations du tirage</h3>
          <div className="row">
            <div className="col-12 col-md-3 col-lg-2 text-center text-decoration-underline fw-bold fs-4 d-flex align-items-center ps-3 mb-3">
              <span>{pageModel?.tirage?.dateOuvertureString.toLowerCase()}</span>
            </div>
            <div className="col-12 col-md-9 col-lg-10">
              <TirageTable tirage={pageModel?.tirage} model={pageModel} lines={1} />
            </div>
          </div>
        </div>
      </div>
      {achatResult && (isTabletMedia || isDesktopMedia) && (
        <div className="alert alert-danger mb-2">
          <div className="fw-bold">
            Il est important de ne pas rafraîchir et de laisser le processus se compléter jusqu&apos;au
            message de confirmation d&apos;achat afin d&apos;éviter qu&apos;il y ait un problème lors de votre
            transaction.
          </div>
        </div>
      )}
      {isConnected && (
        <div className="card card-3-light mb-3 py-3">
          <div className="card-title">
            <h2 className={'text-center'}>Votre Commande</h2>
          </div>
          <div className="card-body">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-6 d-flex justify-content-center">
                <AchatForm
                  literals={literals}
                  model={pageModel}
                  tirageId={tirageIdHook}
                  submitFormflow={handleAchatFormFlow}
                  ref={achatFormRef}
                />
              </div>
              {achatResult && (
                <div className="col-12 col-lg-6">
                  <h1 className="text-center mt-3">Paiement</h1>
                  <p className="text-center">
                    *** Merci de remplir le champ &quot;Email&quot; afin que votre reçu vous soit envoyé. ***
                  </p>
                  <p className="text-center">
                    *** En cas de carte prépayée veuillez saisir votre nom dans le champ du « nom du titulaire
                    de la carte » ***
                  </p>
                </div>
              )}
            </div>
            {achatResult && (
              <div className="row justify-content-center">
                {isMobileMedia && (
                  <div className="alert alert-warning mb-2">
                    <div className="fw-bold">
                      Il est important de ne pas rafraîchir et de laisser le processus se compléter jusqu&apos;au
                      message de confirmation d&apos;achat afin d&apos;éviter qu&apos;il y ait un problème lors de
                      votre transaction.
                    </div>
                  </div>
                )}
                <div className="col-12 col-md-10">
                  <MonerisCheckout
                    achatResult={achatResult}
                    model={pageModel}
                    setAchatResultState={setAchatResult}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Achats;
